import Relay from 'react-relay/classic';

class LearnerViewCardsRoute extends Relay.Route {}

LearnerViewCardsRoute.queries = {
  rootQ: () => Relay.QL`
    query {
      learnerCourse(id: $courseId)
    }
  `
};
/* ,
pathInfo: () => Relay.QL`
  query {
    learnerCurriculum(id: $pathId)
  }
` */

LearnerViewCardsRoute.routeName = 'LearnerViewCardsRoute';

export default LearnerViewCardsRoute;
